<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="800px" append-to-body
    :destroy-on-close="true" :before-close="cancel">
    <div class="el-dialog-div">
     <div class="sign-info-wrapper" v-if="Object.keys(info).length > 0">
        <div class="section-sub-title"><i class="el-icon-edit-outline"></i> 合同签署信息</div>
        <div class="detail-grid single-column">
          <div class="detail-item">
            <span class="detail-label">签署状态</span>
            <span class="detail-value">
              <el-tag :type="getSignColor(info.signStatus, 'tagType')"
                :style="{ color: getSignColor(info.signStatus, 'color'), 'background-color': getSignColor(info.signStatus, 'backgroundColor') }"><i
                  :class="getSignColor(info.signStatus, 'icon')"></i>
                {{ getSignColor(info.signStatus, 'name') + (info.signStatus === 'SIGNED' ? (!info.annex ? '(线上)' :
                  '(线下)') : '') }}</el-tag>
            </span>
          </div>
          <div class="detail-item" v-if="info.signStatus === 'INITIATION_FAILED'">
            <span class="detail-label">签署发起失败原因</span>
            <span class="detail-value">{{ info.failReason }}</span>
          </div>
          <div class="detail-item" v-if="info.signStatus === 'VISA_REFUSAL'">
            <span class="detail-label">拒签原因</span>
            <span class="detail-value">{{ info.resultDescription }}</span>
          </div>
        </div>
      </div>
      <el-tabs v-model="activeIndex" v-if="contract.length > 1">
        <el-tab-pane v-for="(item, index) in contract" :key="index" :label="'合同' + (index + 1)"
          :name="String(index)"></el-tab-pane>
      </el-tabs>
      <div class="section-card">
        <div class="section-header-bar" @click="toggleSection('baseInfo')">
          <div class="section-title"><i class="el-icon-s-order"></i> 合同基础信息</div>
          <i :class="sectionOpen.baseInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
        <div v-show="sectionOpen.baseInfo">
          <div class="detail-grid">
            <div class="detail-item">
              <span class="detail-label">合同编号</span>
              <span class="detail-value">{{ contract[Number(activeIndex)].contractNumber }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">合同名称</span>
              <span class="detail-value">{{ contract[Number(activeIndex)].contractName }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">有效期限</span>
              <span class="detail-value"><el-tag size="small">{{ contract[Number(activeIndex)].expirationDate + '年' }}</el-tag></span>
            </div>
            <div class="detail-item">
              <span class="detail-label">签订地点</span>
              <span class="detail-value">{{ contract[Number(activeIndex)].signingPlace }}</span>
            </div>
            <div class="detail-item" v-if="contract[Number(activeIndex)].executeContractNumber !== ''">
              <span class="detail-label">执行合同编号</span>
              <span class="detail-value">{{ contract[Number(activeIndex)].executeContractNumber }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">合同金额</span>
              <span class="detail-value"><span class="amount-text">{{ formatAmount(contract[Number(activeIndex)].contractAmount) }}</span></span>
            </div>
            <div class="detail-item" v-if="Object.keys(info).length <= 0">
              <span class="detail-label">可开票金额</span>
              <span class="detail-value"><span class="amount-text">{{ ['PREPAYMENTS', 'FORMAL',
                'IMPORT_PREPAYMENTS'].includes(contract[Number(activeIndex)].contractType)
                ? formatAmount(contract[Number(activeIndex)].invoicedAmount) : 'NA' }}</span></span>
            </div>
            <div class="detail-item"
              v-if="['PREPAYMENTS', 'IMPORT_PREPAYMENTS'].includes(contract[Number(activeIndex)].contractType)">
              <span class="detail-label">增值金额</span>
              <span class="detail-value"><span class="amount-text">{{ formatAmount(contract[Number(activeIndex)].addedAmount) + ' (' +
                getProportion(contract[Number(activeIndex)].contractAmount, contract[Number(activeIndex)].addedAmount) + ')' }}</span></span>
            </div>
            <div class="detail-item" v-if="contract[Number(activeIndex)].impairmentAmount !== ''">
              <span class="detail-label">转预付款金额</span>
              <span class="detail-value"><span class="amount-text">{{ contract[Number(activeIndex)].impairmentAmount }}</span></span>
            </div>
            <div class="detail-item" v-if="contract[Number(activeIndex)].impairmentAmount !== ''">
              <span class="detail-label">转换原因</span>
              <span class="detail-value">{{ contract[Number(activeIndex)].impairmentRemark }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">合同分类</span>
              <span class="detail-value">
                <el-tag size="small" :type="getContractColor(contract[Number(activeIndex)].contractType, 'tagType')" :style="{
                  color: getContractColor(contract[Number(activeIndex)].contractType, 'color'),
                  'background-color': getContractColor(contract[Number(activeIndex)].contractType, 'backgroundColor'),
                  'border-color': getContractColor(contract[Number(activeIndex)].contractType, 'borderColor')
                }">
                  {{ getContractColor(contract[Number(activeIndex)].contractType, 'name') }}</el-tag>
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">合同类型</span>
              <span class="detail-value"><el-tag size="small" type="warning">{{ contract[Number(activeIndex)].projectType }}</el-tag></span>
            </div>
            <div class="detail-item"
              v-if="['返样/暂存样品', '预付款扣款（返样/暂存样品）'].includes(contract[Number(activeIndex)].projectType)">
              <span class="detail-label">样品处理方式</span>
              <span class="detail-value">{{ contract[Number(activeIndex)].sampleManagement === 'RETURN_SAMPLE' ? '返样' : '暂存样品' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">核酸抽提</span>
              <span class="detail-value">
                <el-tag size="small" type="success" v-if="contract[Number(activeIndex)].extractionFlag">是</el-tag>
                <el-tag size="small" type="danger" v-else>否</el-tag>
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">客户联系人</span>
              <span class="detail-value">{{ contract[Number(activeIndex)].customerContacts }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">受托方</span>
              <span class="detail-value">{{ contract[Number(activeIndex)].trusteeCompany }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">受托方联系人</span>
              <span class="detail-value">{{ contract[Number(activeIndex)].trusteeContacts }}</span>
            </div>
            <div class="detail-item" v-if="contract[Number(activeIndex)].priceFilePath">
              <span class="detail-label">价格申请截图</span>
              <span class="detail-value">
                <div class="attachment-actions">
                  <el-button size="mini" type="primary" icon="el-icon-download" plain @click="download(contract[Number(activeIndex)].id, 'price')">下载</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-view" plain @click="preview(contract[Number(activeIndex)].id, 'price')">预览</el-button>
                </div>
              </span>
            </div>
            <div class="detail-item" v-if="contract[Number(activeIndex)].contractFilePath !== ''">
              <span class="detail-label">附件</span>
              <span class="detail-value">
                <div class="attachment-actions">
                  <el-button size="mini" type="primary" icon="el-icon-download" plain @click="download(contract[Number(activeIndex)].id, 'contract')">下载</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-view" plain @click="preview(contract[Number(activeIndex)].id, 'contract')">预览</el-button>
                </div>
              </span>
            </div>
            <div class="detail-item full-width" v-if="findProjectAnnexProject(contract[Number(activeIndex)])">
              <span class="detail-label">需做的理化性质列表</span>
              <span class="detail-value">
                <div class="attachment-actions">
                  <el-button size="mini" type="primary" icon="el-icon-download" plain @click="downloadProjectAnnexFile(contract[Number(activeIndex)].id, findProjectAnnexProject(contract[Number(activeIndex)]).projectMainTypeId)">下载</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-view" plain @click="previewProjectAnnexFile(contract[Number(activeIndex)].id, findProjectAnnexProject(contract[Number(activeIndex)]).projectMainTypeId)">预览</el-button>
                </div>
              </span>
            </div>
            <div class="detail-item full-width">
              <span class="detail-label">备注</span>
              <span class="detail-value">{{ contract[Number(activeIndex)].remark }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="section-card"
        v-if="['预付款扣款（测序分析）', '测序分析'].includes(contract[Number(activeIndex)].projectType) && contract[Number(activeIndex)].contractType !== 'DEVELOPMENT' && formattedMoreAnalysis[Number(activeIndex)].length > 0">
        <div class="section-header-bar" @click="toggleSection('analysis')">
          <div class="section-title"><i class="el-icon-s-order"></i> 补充分析要求</div>
          <i :class="sectionOpen.analysis ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
       <div v-show="sectionOpen.analysis">
          <div class="detail-grid">
            <div class="detail-item"
              v-for="(item, index) in formattedMoreAnalysis[Number(activeIndex)]" :key="index">
              <span class="detail-label">{{ item }}金额</span>
              <span class="detail-value"><span class="amount-text">{{ translatedObject[Number(activeIndex)][item] }}</span></span>
            </div>
            <div class="detail-item" v-if="contract[Number(activeIndex)].seniorAnalysisAnnex !== ''">
              <span class="detail-label">高级分析附件</span>
              <span class="detail-value">
                <div class="attachment-actions">
                  <el-button size="mini" type="primary" icon="el-icon-download" plain @click="download(contract[Number(activeIndex)].id, 'senior')">下载</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-view" plain @click="preview(contract[Number(activeIndex)].id, 'senior')">预览</el-button>
                </div>
              </span>
            </div>
            <div class="detail-item" v-if="contract[Number(activeIndex)].customizedAnalysisAnnex !== ''">
              <span class="detail-label">个性化分析附件</span>
              <span class="detail-value">
                <div class="attachment-actions">
                  <el-button size="mini" type="primary" icon="el-icon-download" plain @click="download(contract[Number(activeIndex)].id, 'customized')">下载</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-view" plain @click="preview(contract[Number(activeIndex)].id, 'customized')">预览</el-button>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="section-card"
        v-if="['预付款扣款（测序分析）', '预付款扣款（裸测）', '测序分析', '裸测'].includes(contract[Number(activeIndex)].projectType)">
        <div class="section-header-bar" @click="toggleSection('returnSample')">
          <div class="section-title"><i class="el-icon-s-order"></i> 返样</div>
          <i :class="sectionOpen.returnSample ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
       <div v-show="sectionOpen.returnSample">
          <div class="detail-grid">
            <div class="detail-item">
              <span class="detail-label">是否返样</span>
              <span class="detail-value">
   {{ contract[Number(activeIndex)].generateContractInfo?.returnSampleBo?.returnSampleFlag ? '是' : '否' }}
              </span>
            </div>
            <div class="detail-item"
              v-if="contract[Number(activeIndex)].generateContractInfo?.returnSampleBo?.returnSampleFlag">
              <span class="detail-label">服务费(返样)</span>
              <span class="detail-value"><span class="amount-text">{{
                formatAmount(contract[Number(activeIndex)].generateContractInfo?.returnSampleBo.returnSampleAmount)
                }}</span></span>
            </div>
            <div class="detail-item full-width"
              v-if="contract[Number(activeIndex)].generateContractInfo?.returnSampleBo?.returnSampleFlag && Number(contract[Number(activeIndex)].generateContractInfo?.returnSampleBo.returnSampleAmount) === 0">
              <span class="detail-label">金额为0原因</span>
              <span class="detail-value">{{ contract[Number(activeIndex)].generateContractInfo?.returnSampleBo.reason }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="section-card" v-if="project[Number(activeIndex)].length > 0">
        <div class="section-header-bar" @click="toggleSection('projectInfo')">
          <div class="section-title"><i class="el-icon-s-order"></i> 项目信息</div>
          <i :class="sectionOpen.projectInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
        <div v-show="sectionOpen.projectInfo">
          <project-info-dialog :table-data="project[Number(activeIndex)]"></project-info-dialog>
        </div>
      </div>

      <!-- 纯分析项目信息 -->
      <div class="section-card" v-if="showPureAnalysisInfo">
        <div class="section-header-bar" @click="toggleSection('pureAnalysis')">
          <div class="section-title"><i class="el-icon-s-data"></i> 纯分析项目</div>
          <i :class="sectionOpen.pureAnalysis ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
        <div v-show="sectionOpen.pureAnalysis">
          <div class="detail-grid">
            <div class="detail-item">
              <span class="detail-label">纯分析类型</span>
              <span class="detail-value">{{ pureAnalysisTypeName }}</span>
            </div>
          </div>
          <!-- 合同-项目分组表格：每行一组，清晰展示绑定关系 -->
          <div class="change-data-wrapper" v-if="pureAnalysisTableData.length > 0">
            <el-table :data="pureAnalysisTableData" stripe style="width: 100%"
              header-row-class-name="headerTable" :cell-style="{ padding: '8px 0' }">
              <el-table-column label="序号" align="center" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.row.index }}</span>
                </template>
              </el-table-column>
              <el-table-column label="关联合同" align="center" min-width="180">
                <template slot-scope="scope">
                  <span class="highlight-text">{{ scope.row.contractNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column label="项目" align="center" min-width="250">
                <template slot-scope="scope">
                  <el-tag v-for="(p, i) in scope.row.projects" :key="i" size="small"
                    style="margin: 2px 4px 2px 0;">{{ p }}</el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 解离项目投递方式信息展示 -->
      <div class="section-card" v-if="contract[Number(activeIndex)].protectiveFluidInfo?.protectiveFluidMethod">
        <div class="section-header-bar" @click="toggleSection('protectiveFluid')">
          <div class="section-title"><i class="el-icon-s-order"></i> 解离项目投递方式</div>
          <i :class="sectionOpen.protectiveFluid ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
        <div v-show="sectionOpen.protectiveFluid">
          <div class="detail-grid">
            <div class="detail-item">
              <span class="detail-label">投递方式</span>
              <span class="detail-value">{{ contract[Number(activeIndex)].protectiveFluidInfo.protectiveFluidMethod === 'DOOR' ? '上门' : (contract[Number(activeIndex)].protectiveFluidInfo.protectiveFluidMethod === 'MAIL' ? '邮寄' : '') }}</span>
            </div>
            <template v-if="contract[Number(activeIndex)].protectiveFluidInfo.protectiveFluidMethod === 'DOOR'">
              <div class="detail-item">
                <span class="detail-label">上门时间</span>
                <span class="detail-value">{{ contract[Number(activeIndex)].protectiveFluidInfo.doorInfo.doorTime }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">上门费用</span>
                <span class="detail-value">{{ contract[Number(activeIndex)].protectiveFluidInfo.doorInfo.doorFee }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">联系方式</span>
                <span class="detail-value">{{ contract[Number(activeIndex)].protectiveFluidInfo.doorInfo.phone }}</span>
              </div>
              <div class="detail-item full-width">
                <span class="detail-label">上门地址</span>
                <span class="detail-value">{{ contract[Number(activeIndex)].protectiveFluidInfo.doorInfo.address }}</span>
              </div>
            </template>
            <template v-if="contract[Number(activeIndex)].protectiveFluidInfo.protectiveFluidMethod === 'MAIL'">
              <div class="detail-item">
                <span class="detail-label">邮寄时间</span>
                <span class="detail-value">{{ contract[Number(activeIndex)].protectiveFluidInfo.materialMailInfo.mailTime }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">收件人</span>
                <span class="detail-value">{{ contract[Number(activeIndex)].protectiveFluidInfo.materialMailInfo.recipient }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">联系方式</span>
                <span class="detail-value">{{ contract[Number(activeIndex)].protectiveFluidInfo.materialMailInfo.phone }}</span>
              </div>
              <div class="detail-item full-width">
                <span class="detail-label">收件地址</span>
                <span class="detail-value">{{ contract[Number(activeIndex)].protectiveFluidInfo.materialMailInfo.address }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="section-card" v-if="flatMaterialTracking.length > 0">
        <div class="section-header-bar" @click="toggleSection('materials')">
          <div class="section-title"><i class="el-icon-s-order"></i> 物料信息</div>
          <i :class="sectionOpen.materials ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
       <div v-show="sectionOpen.materials">
          <div class="change-data-wrapper">
            <el-table :data="flatMaterialTracking" stripe style="width: 100%" max-height="400"
              header-row-class-name="headerTable" :cell-style="{ padding: '8px 0' }"
              :span-method="materialSpanMethod">
              <el-table-column label="物料状态" align="center" min-width="100">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.statusType" size="small">{{ scope.row.statusText }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="materialName" label="物料名称" align="center" min-width="180">
                <template slot-scope="scope">
                  <span class="material-name">{{ scope.row.materialName || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="specs" label="物料规格" align="center" min-width="120">
                <template slot-scope="scope">
                  <span>{{ scope.row.specs || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="number" label="申领数量" align="center" min-width="120">
                <template slot-scope="scope">
                  <span class="quantity-text">{{ scope.row.number }} <span class="unit-text">支</span></span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <div class="section-card" v-if="contract[Number(activeIndex)].hardDiskPurchaseInfo?.length > 0">
        <div class="section-header-bar" @click="toggleSection('hardDisk')">
          <div class="section-title"><i class="el-icon-s-order"></i> 硬盘选购信息</div>
          <i :class="sectionOpen.hardDisk ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
        <div v-show="sectionOpen.hardDisk">
          <div class="change-data-wrapper">
            <el-table :data="contract[Number(activeIndex)].hardDiskPurchaseInfo" stripe style="width: 100%"
              max-height="250" header-row-class-name="headerTable" :cell-style="{ padding: '8px 0' }">
              <el-table-column label="硬盘大小" align="center" min-width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.hardDiskSize || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="项目金额" align="center" min-width="150">
                <template slot-scope="scope">
                  <span class="amount-text">{{ (scope.row.projectAmount !== undefined && scope.row.projectAmount !== null) ? scope.row.projectAmount : '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量" align="center" min-width="120">
                <template slot-scope="scope">
                  <span>{{ (scope.row.sampleCount !== undefined && scope.row.sampleCount !== null) ? scope.row.sampleCount : '-' }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" class="title" @click="cancel">确定</el-button>
    </div>
    <file-preview v-if="showFile" :show-dialog="showFile" :response="fileInfo" @submit="close"></file-preview>
  </el-dialog>
</template>

<script>

import {attachmentContract, getAllContract} from "@/api/dilivery/sales/contract";
import FilePreview from "@/components/file/FilePreview.vue";
import {getProjectList} from "@/api/dilivery/project";
import ProjectInfoDialog from "@/components/sales/ProjectInfoDialog.vue";
import { getContractColor, getStatusColor, getSignColor } from "@/color";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { getProportion } from "@/utils/float_decimal";
import projectAnnexMixin from "@/mixins/projectAnnexMixin";
import detailCommonMixin from "@/mixins/detailCommonMixin";
const baseURL = process.env.VUE_APP_BASE_API

export default {
  name: "ContractDetails",
  mixins: [projectAnnexMixin, detailCommonMixin],
  components: {ProjectInfoDialog, FilePreview},
  props:{
    showDialog:{
      default:false
    },
    selectDetail:{
      default:() => ({})
    },
    info:{
      default:() => ({})
    }
  },
  data() {
    return {
      title: '查看合同详情',
      showFile: false,
      fileInfo: '',
      contract:[],
      activeIndex:'0',
      ProjectOption: [],//项目
      enforceContractOption: [],//已执行合同（供纯分析项目展示）
      sectionOpen: {
        baseInfo: true,
        analysis: true,
        returnSample: true,
        projectInfo: true,
        pureAnalysis: true,
        protectiveFluid: true,
        materials: true,
        hardDisk: true
      }
    }
  },
  computed: {
    formattedMoreAnalysis() {
      return this.contract.map(itemA => {
        return itemA.moreAnalysis.map(item => {
          switch (item) {
            case 'SENIOR_ANALYSIS':
              return '高级分析';
            case 'CUSTOMIZED_ANALYSIS':
              return '个性化分析';
            default:
              return item;
          }
        });
      })
    },
    translatedObject() {
      return this.contract.map(item => {
        const newObject = {};
        for (const key in item.moreAnalysisRequest) {
          let newKey = key;
          switch (key) {
            case 'SENIOR_ANALYSIS':
              newKey = '高级分析';
              break;
            case 'CUSTOMIZED_ANALYSIS':
              newKey = '个性化分析';
              break;
            default:
              break;
          }
          newObject[newKey] = item.moreAnalysisRequest[key];
        }
        return newObject;
      })
    },
    project() {
      return this.contract.map(itemA => {
        return itemA.specificProjectType.map(item => {
          const type = this.ProjectOption.find(itemB => itemB.id === item.projectMainTypeId)
          if (type) {
            return {
              ...item,
              ...type
            }
          } else {
            return {
              ...item,
              model: '',
              name: ''
            }
          }
        })
      })
    },
    flatMaterialTracking() {
      const contractItem = this.contract[Number(this.activeIndex)]
      return this._buildFlatMaterialTracking(contractItem?.protectiveFluidMail, contractItem?.materials)
    },
    currentContract() {
      return this.contract[Number(this.activeIndex)] || {}
    },
    pureAnalysisInfo() {
      return this.currentContract.pureAnalysisInfo || {}
    },
    showPureAnalysisInfo() {
      const info = this.pureAnalysisInfo
      const hasContracts = Array.isArray(info.contracts) &&
        info.contracts.some(c => c.contractId || (c.projectIds && c.projectIds.length))
      return this.currentContract.contractType === 'TEAM' &&
        this.currentContract.projectType === '纯分析' &&
        !!(info.pureAnalysisType || hasContracts)
    },
    pureAnalysisTypeName() {
      // 与后端 pureAnalysisType 枚举保持一致
      const enumMap = {
        AFTER_SALES_ANALYSIS: '售后分析',
        RAW_DATA_RERELEASE: '原始数据重释放',
        PURE_ANALYSIS: '纯分析'
      }
      const val = this.pureAnalysisInfo.pureAnalysisType
      if (!val) return '-'
      return enumMap[val] || val
    },
    // 按组解析：每组包含 contractId / projectIds / 已加载的合同对象
    pureAnalysisContracts() {
      const contracts = Array.isArray(this.pureAnalysisInfo.contracts) ? this.pureAnalysisInfo.contracts : []
      return contracts.map(c => ({
        contractId: c.contractId,
        projectIds: Array.isArray(c.projectIds) ? c.projectIds : [],
        contract: c.contractId ? (this.enforceContractOption.find(x => String(x.id) === String(c.contractId)) || null) : null
      }))
    },
    // 按组生成表格数据：每行一组合同+项目，清晰展示绑定关系
    pureAnalysisTableData() {
      const list = this.pureAnalysisContracts
      if (list.length === 0) return []
      return list.map((g, idx) => {
        const spt = g.contract?.specificProjectType || []
        const projects = g.projectIds.map(pid => {
          // 优先从项目字典解析：仅展示具体项目名（不含 model 前缀）
          const dictItem = this.ProjectOption.find(item => String(item.id) === String(pid))
          if (dictItem) return dictItem.name
          // 兜底：从合同 specificProjectType 解析（兼容旧数据，仅展示具体项目名）
          const proj = spt.find(p => String(p.projectMainTypeId) === String(pid))
          return proj ? proj.projectType : pid
        })
        return {
          index: idx + 1,
          contractNumber: g.contract ? g.contract.contractNumber : (g.contractId || '-'),
          projects: projects.length ? projects : ['-']
        }
      })
    }
  },
  watch: {
    selectDetail: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.contract = newVal.map(item => {
            return {
              id:item.id,
              createBy: item.createBy,
              createTime: item.createTime,
              executeContractNumber: item.executeContractNumber ?? '',
              analysisRequest: item.analysisRequest === 'STANDARD_ANALYSIS' ? '标准分析' : '',
              moreAnalysis: Object.keys(item.moreAnalysisRequest ?? {}),
              moreAnalysisRequest: {...item.moreAnalysisRequest??{}},
              salesName: item?.sales?.name ?? '',
              // pureAnalysisEvaluate: item?.pureAnalysisEvaluate?.name??'',
              seniorAnalysisAnnex: item.seniorAnalysisAnnex ?? '',
              customizedAnalysisAnnex: item.customizedAnalysisAnnex ?? '',
              materials: item.materials ?? [],
              extractionFlag: item.generateContractInfo?.extractionFlag ?? '',
              generateContractInfo: item.generateContractInfo ?? {},
              contractDraftingDate: item.contractDraftingDate ?? '',
              contractType: item.contractType ?? '',
              projectType: item.projectType ?? '',
              contractAmount: item.contractAmount ?? '',
              addedAmount: item.addedAmount ?? '',
              invoicedAmount: item.invoicedAmount ?? '',
              contractNumber: item.contractNumber ?? '',
              contractName: item.contractName ?? '',
              signingDate: item.signingDate ?? '',
              signingPlace: item.signingPlace ?? '',
              expirationDate: item.expirationDate ?? '',
              specificProjectType: item.specificProjectType ?? [],
              hardDiskPurchaseInfo: item.hardDiskPurchaseInfo ?? [],
              customerContacts: item?.customerContacts?.contactName ?? '',
              trusteeCompany: item?.baseCompany?.companyName ?? '',
              trusteeContacts: item?.trusteeContacts?.name ?? '',
              rejectionReason: item.rejectionReason ?? '',
              remark: item.remark ?? '',
              status: item.status ?? '',
              contractFilePath: item.contractFilePath ?? '',
              operatingPersonName: item.operatingPersonName ?? '',
              operatingTime: item.operatingTime ?? '',
              impairmentAmount: item.impairmentAmount ?? '',
              impairmentRemark: item.impairmentRemark ?? '',
              priceFilePath: item.priceFilePath ?? '',
              sampleManagement: item.sampleManagement ?? '',
              protectiveFluidInfo: item.protectiveFluidInfo ?? {protectiveFluidMethod: '', doorInfo: {}, materialMailInfo: {}},
              protectiveFluidMail: item.protectiveFluidMail ?? [],
              pureAnalysisInfo: item.pureAnalysisInfo ?? {}
            }
          })
          // 若存在 TEAM+纯分析 合同，按各组 contractId 定向获取（供纯分析项目回显）
          this.contract
            .filter(c => c.contractType === 'TEAM' && c.projectType === '纯分析' && c.pureAnalysisInfo)
            .forEach(c => {
              const info = c.pureAnalysisInfo
              const ids = (Array.isArray(info.contracts) ? info.contracts : []).map(g => g.contractId).filter(Boolean)
              if (ids.length > 0) {
                this.loadEnforceContractOption(info.pureAnalysisType, ids)
              }
            })
        }
      },
      immediate: true
    },
    info: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.title = '查看合同签署信息'
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getLexiconOptions()
    this.getProjectOption([])
  },
  methods: {
    getProportion,
    getStatusColor,
    getSignColor,
    getContractColor,
    getProjectOption(list) {
      let data = {
        "query#id.IN": list.join(',')
      }
      getProjectList(data).then(res => {
        if (res.code === 200) {
          this.ProjectOption = res.data
        }
      })
    },
    // 按各组 contractId 定向获取合同（供纯分析项目展示解析）
    loadEnforceContractOption(pureAnalysisType, contractIds) {
      const ids = (Array.isArray(contractIds) ? contractIds : [contractIds]).filter(Boolean)
      if (ids.length === 0) return
      const typeMap = { AFTER_SALES_ANALYSIS: 'ANALYSIS_OVER_CONTRACT', RAW_DATA_RERELEASE: 'RELEASED_RAW_DATA_CONTRACT' }
      const contractType = typeMap[pureAnalysisType]
      if (!contractType) return
      const missing = ids.filter(id => !this.enforceContractOption.some(c => String(c.id) === String(id)))
      if (missing.length === 0) return
      getAllContract(contractType, { 'query#id.IN': missing.join(',') }).then(res => {
        if (res.code === 200 && Array.isArray(res.data)) {
          this.enforceContractOption = [...this.enforceContractOption, ...res.data]
        }
      }).catch(err => {
        console.log(err);
      })
    },
    cancel() {
      this.$emit('submit', 'cancel')
    },
    async download(id, type) {
      await this.downloadContractAttachment(id, type)
    },
    async preview(id, type) {
      await this.previewContractAttachment(id, type)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixins.scss";
@import "@/assets/css/detail.css";

.el-dialog-div {
  @include thin-scrollbar(8px, #888);
  max-height: 90vh;
  background: #fff;
}

/* 签署信息区域 */
.sign-info-wrapper {
  margin-bottom: 20px;
  padding: 16px;
  background: #fafbfc;
  border-radius: 6px;
  border: 1px solid #ebeef5;
}

.section-sub-title {
  font-weight: 600;
  font-size: 14px;
  color: #303133;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 区块卡片 */








/* 保护剂表格 */



</style>
